// Import sentry first so it initializes before React mounts
import "@/lib/sentry";
import { Sentry } from "@/lib/sentry";

import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

function SentryFallback({ error }: { error: Error }) {
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-slate-50 px-4 py-12 gap-4 text-center">
      <h1 className="text-2xl font-bold text-slate-900">Something went wrong</h1>
      <p className="text-slate-500 max-w-sm">
        An unexpected error occurred. Our team has been notified. Please refresh the page to try again.
      </p>
      {import.meta.env.DEV && (
        <pre className="text-left text-xs bg-red-50 border border-red-200 rounded p-4 max-w-xl overflow-auto text-red-700">
          {error.message}
        </pre>
      )}
      <button
        onClick={() => window.location.reload()}
        className="mt-2 px-4 py-2 bg-orange-500 text-white rounded-md font-semibold hover:bg-orange-600"
      >
        Refresh page
      </button>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={({ error }) => <SentryFallback error={error as Error} />}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Sentry.ErrorBoundary>
);
